export default __webpack_public_path__ + "static/H_Big_02-ff1a2803f050fcb1f8e3f6824f9cf844.webm";